import type { NavLink } from "@/types/NavLink";

export const NAV_LINKS_FOOTER: NavLink[] = [
  // { label: "Accueil", href: "/" },
  { label: "Première visite", href: "/premiere-visite" },
  { label: "À propos", href: "/a-propos" },
  { label: "Prédications", href: "/predications" },
  // { label: "Contact", href: "/contact" },
];
